import React, { useState, useEffect } from "react";
import axios from 'axios'
import toast from "react-hot-toast";
import { FaSearch, FaUserCheck } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";

function Activity({ token }) {

  const location = useLocation();
  const { dealer } = location.state;
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [list, setList] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [machineEnquiries, setMachineEnquiries] = useState([]);
  const [partEnquiries, setPartEnquiries] = useState([]);
  const [quotations, setQuotations] = useState([]);
  const [withdrawals, setWithdrawals] = useState([]);
  const [activeTab, setActiveTab] = useState("");
 const[vehicleList,setVehicleList] = useState([]);
 const[userEnq,setUserEnq] = useState([]);
const[cartList,setCartList] = useState([]);
const[userPart,setUserPart] = useState([]);
const[ticket,setTicket] = useState([]);  

const[driverWithdrawal,setDriverWithdrawal] = useState([]);
const[driverEnq,setDriverEnq] = useState([]);
const[driverEarning,setDriverEarning] = useState([]);


const user_type = location.state?.user_type;

useEffect(() => {
  if (user_type === "driver") {
    setActiveTab("driverEnq");
  } else if (user_type === "dealer") {
    setActiveTab("machine");
  } else if (user_type === "customer") {
    setActiveTab("vehicle");
  }
}, [user_type]);

  const fetchDealerEnq = async () => {
    try {
      const res = await axios.get(
        `https://api.krimotion.in/get-dealer-enquiries/${dealer.id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setMachineEnquiries(res.data || []);


    } catch (error) {
      console.log(error);
    }
  };

  const fetchDealerPartEnq = async () => {
    try {
      const res = await axios.get(
        `https://api.krimotion.in/get-dealer-parts-enquiries/${dealer.id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setPartEnquiries(res.data || []);

    } catch (error) {
      console.log(error);
    }
  };

  const fetchDealerQupotation = async () => {
    try {
      const res = await axios.get(
        `https://api.krimotion.in/get-dealer-parts-quotation/${dealer.id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setQuotations(res.data || []);


    } catch (error) {
      console.log(error);
    }
  };


  const fetchDealerWithdrawal = async () => {
    try {
      const res = await axios.get(
        `https://api.krimotion.in/get-dealer-withdrawal/${dealer.id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setWithdrawals(res.data || []);

    } catch (error) {
      console.log(error);
    }
  };

  //uwer api
    const fetchUserVehicleList = async () => {
    try {
      const res = await axios.get(
        `https://api.krimotion.in/get-vehicle/${dealer.id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

    setVehicleList(res.data);

    } catch (error) {
      console.log(error);
    }
  };

  const fetchuserEnqList = async () => {
    try {
      const res = await axios.get(
        `https://api.krimotion.in/get-user-enquiries/${dealer.id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

   setUserEnq(res.data);

    } catch (error) {
      console.log(error);
    }
  };


    const fetchCartList = async () => {
    try {
      const res = await axios.get(
        `https://api.krimotion.in/get-mycart/${dealer.id}/${user_type}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

   setCartList(res.data);

    } catch (error) {
      console.log(error);
    }
  };


  
    const fetchUserPartEnq = async () => {
    try {
      const res = await axios.get(
        `https://api.krimotion.in/get-parts-enquiries/${dealer.id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

  setUserPart(res.data);

    } catch (error) {
      console.log(error);
    }
  };


  const fetchTicket = async () => {
    try {
      const res = await axios.get(
        `https://api.krimotion.in/get-tickets/${dealer.id}/${user_type}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

  setTicket(res.data);


    } catch (error) {
      console.log(error);
    }
  };

//api for driver
  const fetchDriverEnqList = async () => {
    try {
      const res = await axios.get(
        `https://api.krimotion.in/get-driver-enquiry/${dealer.id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

   setDriverEnq(res.data);
  

    } catch (error) {
      console.log(error);
    }
  };

    const fetchDriverEarning = async () => {
    try {
      const res = await axios.get(
        `https://api.krimotion.in/get-driver-earning/${dealer.id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

   setDriverEarning(res.data);


    } catch (error) {
      console.log(error);
    }
  };
    const fetchDriverWithdrawal = async () => {
    try {
      const res = await axios.get(
        `https://api.krimotion.in/get-driver-withdrawal/${dealer.id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

   setDriverWithdrawal(res.data);
   

    } catch (error) {
      console.log(error);
    }
  };


  useEffect(() => {
    fetchDealerEnq();
    fetchDealerPartEnq();
    fetchDealerQupotation();
    fetchDealerWithdrawal();

    fetchTicket();
    fetchUserPartEnq();
    fetchCartList();
    fetchuserEnqList();
    fetchUserVehicleList();

    fetchDriverEnqList();
    fetchDriverEarning();
    fetchDriverWithdrawal();

  }, []);


  const filteredData = Array.isArray(list)
    ? list.filter(itm =>
      Object.values(itm).some(val =>
        String(val).toLowerCase().includes(searchTerm.toLowerCase())
      )
    )
    : [];


  const formatDate = (date) => {
    if (!date) return "-";

    const d = new Date(date);

    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();

    let hours = d.getHours();
    const minutes = String(d.getMinutes()).padStart(2, "0");

    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    hours = String(hours).padStart(2, "0");

    return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
  };


const currentData =
  activeTab === "machine"
    ? machineEnquiries
    : activeTab === "parts"
    ? partEnquiries
    : activeTab === "quotation"
    ? quotations
    : activeTab === "withdraw"
    ? withdrawals
    : ticket;
          

  const currentCustomerData =
  activeTab === "vehicle"
    ? vehicleList
    : activeTab === "enquiry"
    ? userEnq
    : activeTab === "cart"
    ? cartList
    : activeTab === "parts"
    ? userPart
    : ticket;        

const currentDriverData =
  activeTab === "driverEnq"
    ? driverEnq
    : activeTab === "earning"
    ? driverEarning
    : activeTab === "withdrawal"
    ? driverWithdrawal
    : ticket;

  return (
    <div className="container py-4">
      <div className="border-0  mb-3 px-2 py-2  ">

        <div className="d-flex flex-column gap-2">
          <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">

            <h4 className="fw-bold mb-0" style={{ fontSize: "20px" }}>
              Activity List
            </h4>

            <div style={{ flex: 1, maxWidth: "250px" }}>
              <div
                className="d-flex align-items-center rounded-pill overflow-hidden"
                style={{
                  border: "1px solid var(--green)",
                  height: "34px",
                  paddingLeft: "8px",
                  paddingRight: "8px",
                  backgroundColor: "white"
                }}
              >
                <FaSearch style={{ color: "var(--green)", fontSize: "14px" }} />

                <input
                  type="text"
                  className="form-control border-0 shadow-none"
                  placeholder="Search..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  style={{
                    fontSize: "14px",
                    height: "32px",
                    marginLeft: "6px"
                  }}
                />
              </div>
            </div>

          </div>
          <div>
            <button
              className="btn btn-outline-secondary btn-sm"
              onClick={() => navigate(-1)}
            >
              ← Back
            </button>
          </div>

        </div>

      </div>



      <h5>
        <span className="status-badge status-success px-3 py-2">
          {dealer.name}
        </span>
      </h5>

      {user_type === "dealer" && (
         <> 
      <div className="row g-3 mt-3">

        <div className="col-md-3">

          <div
            className={`card shadow-sm text-center p-3 ${activeTab === "machine"
                ? "bg-primary text-white border-primary"
                : "border-0"
              }`}
            style={{
              cursor: "pointer",
              transition: "0.3s",
            }}
            onClick={() => setActiveTab("machine")}
          >

            <h2 className={
              activeTab === "machine"
                ? "text-white"
                : "text-primary"
            }>
              {machineEnquiries.length}
            </h2>

            <h6>Machine Enquiries</h6>
          </div>
        </div>

        <div className="col-md-3">
   
          <div
            className={`card shadow-sm text-center p-3 ${activeTab === "parts"
                ? "bg-primary text-white border-primary"
                : "border-0"
              }`}
            style={{
              cursor: "pointer",
              transition: "0.3s",
            }}
            onClick={() => setActiveTab("parts")}
          >

            <h2 className={
              activeTab === "parts"
                ? " text-white border-success"
                : "text-success"
            }>
              {partEnquiries.length}
            </h2>

            <h6>Parts Enquiries</h6>
          </div>
        </div>

        <div className="col-md-3">
    
          <div
            className={`card shadow-sm text-center p-3 ${activeTab === "quotation"
                ? "bg-primary text-white border-primary"
                : "border-0"
              }`}
            style={{
              cursor: "pointer",
              transition: "0.3s",
            }}
            onClick={() => setActiveTab("quotation")}
          >

            <h2 className={
              activeTab === "quotation"
                ? " text-light border-warning"
                : "text-warning"
            }>
              {quotations.length}
            </h2>

            <h6>Parts Quotations</h6>
          </div>
        </div>

        <div className="col-md-3">
      
          <div
            className={`card shadow-sm text-center p-3 ${activeTab === "withdraw"
                ? "bg-primary text-white border-primary"
                : "border-0"
              }`}
            style={{
              cursor: "pointer",
              transition: "0.3s",
            }}
            onClick={() => setActiveTab("withdraw")}
          >

            <h2 className={
              activeTab === "withdraw"
                ? " text-white border-success"
                : "text-danger"
            }>
              {withdrawals.length}
            </h2>

            <h6>Withdrawals</h6>
          </div>
        </div>

        <div className="col-md-3">
  <div
    className={`card shadow-sm text-center p-3 ${
      activeTab === "ticket"
        ? "bg-primary text-white border-primary"
        : "border-0"
    }`}
    style={{
      cursor: "pointer",
      transition: "0.3s",
    }}
    onClick={() => setActiveTab("ticket")}
  >
    <h2
      className={
        activeTab === "ticket"
          ? "text-white"
          : "text-info"
      }
    >
      {ticket.length}
    </h2>

    <h6>Raised Tickets</h6>
  </div>
</div>

      </div>


      {!showForm && (
        <div className="container-fluid mt-4">
          <div className="row g-4">

            {currentData.length > 0 ? (
              currentData.map((dealer, index) => (
                <div className="col-xl-4 col-lg-6 col-md-6" key={index}>

                  <div className="inventory-card d-flex flex-column h-100">

                
                    <div className="d-flex justify-content-between align-items-start">

                      <div>

                        <h5 className="fw-bold mb-1">

                          {activeTab === "machine" && "🚜 Machine Enquiry"}

                          {activeTab === "parts" && "🛠 Parts Enquiry"}

                          {activeTab === "quotation" && "📄 Parts Quotation"}

                          {activeTab === "withdraw" && "💰 Withdrawal"}

                            {activeTab === "ticket" && "🎫 Raised Ticket"}

                        </h5>

                        <small className="text-muted">

                          {activeTab === "machine" &&
                            formatDate(dealer.enquire_on)}

                          {activeTab === "parts" &&
                            formatDate(dealer.enquire_on)}

                          {activeTab === "quotation" &&
                            formatDate(dealer.quote_date)}

                          {activeTab === "withdraw" &&
                            formatDate(dealer.d_withdraw)}

                              {activeTab === "ticket" && formatDate(dealer.raised_on)}

                        </small>

                      </div>

                <span
  className={`badge ${
    activeTab === "machine"
      ? "bg-primary"
      : activeTab === "parts"
      ? "bg-success"
      : activeTab === "quotation"
      ? "bg-warning text-dark"
      : activeTab === "withdraw"
      ? "bg-danger"
      : "bg-info"
  }`}
>
  {activeTab.toUpperCase()}
</span>

                    </div>


                    <hr />

                    {activeTab === "machine" && (
                      <>
                        <div className="inventory-row">
                          <span>Machine</span>
                          <span>{dealer.machine_name}</span>
                        </div>

                        <div className="inventory-row">
                          <span>Customer</span>
                          <span>{dealer.name}</span>
                        </div>

                        <div className="inventory-row">
                          <span>Status</span>
                          <span>{dealer.enquire_status}</span>
                        </div>

                        <div className="inventory-row">
                          <span>Price</span>
                          <span>₹ {dealer.sell_price}</span>
                        </div>
                      </>
                    )}

                    {activeTab === "parts" && (
                      <>
                        <div className="inventory-row">
                          <span>Customer</span>
                          <span>{dealer.name}</span>
                        </div>

                        <div className="inventory-row">
                          <span>Status</span>
                          <span>{dealer.enquire_status}</span>
                        </div>

                        <div className="inventory-row">
                          <span>Total</span>
                          <span>₹ {dealer.final_amount}</span>
                        </div>
                      </>
                    )}

                    {activeTab === "quotation" && (
                      <>

                        <div className="inventory-row">
                          <span>Customer</span>
                          <span>{dealer.name}</span>
                        </div>

                        <div className="inventory-row">
                          <span>Quote Status</span>
                          <span>{dealer.quote_status}</span>
                        </div>

                        <div className="inventory-row">
                          <span>Amount</span>
                          <span>₹ {dealer.final_amount}</span>
                        </div>
                      </>
                    )}

                    {activeTab === "withdraw" && (
                      <>
                        <div className="inventory-row">
                          <span>Withdrawal</span>
                          <span>₹ {dealer.amount}</span>
                        </div>

                        <div className="inventory-row">
                          <span>Platform Fee</span>
                          <span>₹ {dealer.platform_fee}</span>
                        </div>

                        <div className="inventory-row">
                          <span>Status</span>
                          <span>{dealer.pay_status}</span>
                        </div>
                      </>
                    )}

                    {activeTab === "ticket" && (
  <>
    <div className="inventory-row">
      <span>Description</span>
      <span>{dealer.description}</span>
    </div>

    <div className="inventory-row">
      <span>Status</span>
      <span>{dealer.status}</span>
    </div>

    <div className="inventory-row">
      <span>Raised On</span>
      <span>{formatDate(dealer.raised_on)}</span>
    </div>

    <div className="inventory-row">
      <span>Resolved On</span>
      <span>
        {dealer.resolved_on
          ? formatDate(dealer.resolved_on)
          : "-"}
      </span>
    </div>
  </>
)}

                  </div>

                </div>
              ))
            ) : (
              <div className="col-12">
                <div className="alert alert-light text-center">
                  No Data Found
                </div>
              </div>
            )}




          </div>
        </div>
      )}

        </>

    )}


{user_type === "customer" && (
  <>
    {/* Summary Cards */}
    <div className="row g-3 mt-3">
      {[
        {
          key: "vehicle",
          title: "My Vehicles",
          count: vehicleList.length,
          color: "primary",
          icon: "🚜",
        },
        {
          key: "enquiry",
          title: "Machine Enquiries",
          count: userEnq.length,
          color: "success",
          icon: "📋",
        },
        {
          key: "cart",
          title: "My Cart",
          count: cartList.length,
          color: "warning",
          icon: "🛒",
        },
        {
          key: "parts",
          title: "Parts Enquiries",
          count: userPart.length,
          color: "info",
          icon: "🛠",
        },
        {
          key: "ticket",
          title: "Raise Tickets",
          count: ticket.length,
          color: "danger",
          icon: "🎫",
        },
      ].map((item) => (
        <div className="col-lg col-md-4 col-sm-6" key={item.key}>
          <div
            className={`card shadow-sm text-center p-3 ${
              activeTab === item.key
                ? `bg-${item.color} text-white`
                : "border-0"
            }`}
            style={{ cursor: "pointer" }}
            onClick={() => setActiveTab(item.key)}
          >
            <h2
              className={
                activeTab === item.key
                  ? "text-white"
                  : `text-${item.color}`
              }
            >
              {item.count}
            </h2>

            <h6>
              {item.icon} {item.title}
            </h6>
          </div>
        </div>
      ))}
    </div>

    {/* Detail Cards */}

    <div className="container-fluid mt-4">
      <div className="row g-4">
        {currentCustomerData.length > 0 ? (
          currentCustomerData.map((item, index) => (
            <div className="col-xl-4 col-lg-6" key={index}>
              <div className="inventory-card d-flex flex-column h-100">
                <h5 className="fw-bold mb-3">
                  {activeTab === "vehicle" && "🚜 Vehicle"}
                  {activeTab === "enquiry" && "📋 Machine Enquiry"}
                  {activeTab === "cart" && "🛒 Cart Item"}
                  {activeTab === "parts" && "🛠 Parts Enquiry"}
                  {activeTab === "ticket" && "🎫 Raise Ticket"}
                </h5>

                <hr />

                {/* Vehicle */}

                {activeTab === "vehicle" && (
                  <>
                    <div className="inventory-row">
                      <span>Machine</span>
                      <span>{item.machine_name}</span>
                    </div>

                    <div className="inventory-row">
                      <span>Brand</span>
                      <span>{item.brand}</span>
                    </div>

                    <div className="inventory-row">
                      <span>Year</span>
                      <span>{item.manufacture_year}</span>
                    </div>

                    <div className="inventory-row">
                      <span>Status</span>
                      <span>{item.status}</span>
                    </div>
                  </>
                )}

                {/* Machine Enquiry */}

                {activeTab === "enquiry" && (
                  <>
                    <div className="inventory-row">
                      <span>Machine</span>
                      <span>{item.machine_name}</span>
                    </div>

                    <div className="inventory-row">
                      <span>Status</span>
                      <span>{item.enquire_status}</span>
                    </div>

                    <div className="inventory-row">
                      <span>Price</span>
                      <span>₹ {item.sell_price}</span>
                    </div>
                  </>
                )}

                {/* Cart */}

                {activeTab === "cart" && (
                  <>
                    <div className="inventory-row">
                      <span>Item Name</span>
                      <span>{item.name}</span>
                    </div>

                    <div className="inventory-row">
                      <span>Sun Category</span>
                      <span>{item.sub_category}</span>
                    </div>

                    <div className="inventory-row">
                      <span>Price</span>
                      <span>₹ {item.sell_price}</span>
                    </div>
                  </>
                )}

                {/* Parts */}

                {activeTab === "parts" && (
                  <>
                    <div className="inventory-row">
                      <span>Part</span>
                      <span>{item.items ? JSON.parse(item.items)[0]?.name : "-"}</span>
                    </div>

                    <div className="inventory-row">
                      <span>Status</span>
                      <span>{item.enquire_status}</span>
                    </div>

                    <div className="inventory-row">
                      <span>Total</span>
                      <span>₹ {item.sell_price}</span>
                    </div>
                  </>
                )}

                {/* Ticket */}

                {activeTab === "ticket" && (
                  <>
                    <div className="inventory-row">
                      <span>Description</span>
                      <span>{item.description}</span>
                    </div>

                    <div className="inventory-row">
                      <span>Status</span>
                      <span>{item.status}</span>
                    </div>

                    <div className="inventory-row">
                      <span>Raised</span>
                      <span>{formatDate(item.raised_on)}</span>
                    </div>
                  </>
                )}
              </div>
            </div>
          ))
        ) : (
          <div className="col-12">
            <div className="alert alert-light text-center">
              No Data Found
            </div>
          </div>
        )}
      </div>
    </div>
  </>
)}

{user_type === "driver" && (
  <>
    {/* Top Cards */}

    <div className="row g-3 mt-3">

      <div className="col-md-3">
        <div
          className={`card shadow-sm text-center p-3 ${
            activeTab === "driverEnq"
              ? "bg-primary text-white"
              : "border-0"
          }`}
          style={{ cursor: "pointer" }}
          onClick={() => setActiveTab("driverEnq")}
        >
          <h2 className={activeTab === "driverEnq" ? "text-white" : "text-primary"}>
            {driverEnq.length}
          </h2>
          <h6>Driver Enquiries</h6>
        </div>
      </div>

      <div className="col-md-3">
        <div
          className={`card shadow-sm text-center p-3 ${
            activeTab === "earning"
              ? "bg-success text-white"
              : "border-0"
          }`}
          style={{ cursor: "pointer" }}
          onClick={() => setActiveTab("earning")}
        >
          <h2 className={activeTab === "earning" ? "text-white" : "text-success"}>
            {driverEarning.length}
          </h2>
          <h6>Earnings</h6>
        </div>
      </div>

      <div className="col-md-3">
        <div
          className={`card shadow-sm text-center p-3 ${
            activeTab === "withdrawal"
              ? "bg-danger text-white"
              : "border-0"
          }`}
          style={{ cursor: "pointer" }}
          onClick={() => setActiveTab("withdrawal")}
        >
          <h2 className={activeTab === "withdrawal" ? "text-white" : "text-danger"}>
            {driverWithdrawal.length}
          </h2>
          <h6>Withdrawals</h6>
        </div>
      </div>

      <div className="col-md-3">
        <div
          className={`card shadow-sm text-center p-3 ${
            activeTab === "ticket"
              ? "bg-warning text-white"
              : "border-0"
          }`}
          style={{ cursor: "pointer" }}
          onClick={() => setActiveTab("ticket")}
        >
          <h2 className={activeTab === "ticket" ? "text-white" : "text-warning"}>
            {ticket.length}
          </h2>
          <h6>Raised Tickets</h6>
        </div>
      </div>

    </div>

    {/* Details */}

    <div className="container-fluid mt-4">
      <div className="row g-4">

        {currentDriverData.length > 0 ? (
          currentDriverData.map((item, index) => (
            <div className="col-xl-4 col-lg-6" key={index}>

              <div className="inventory-card d-flex flex-column h-100">

                <div className="d-flex justify-content-between align-items-start">

                  <h5 className="fw-bold">

                    {activeTab === "driverEnq" && "🚜 Driver Enquiry"}

                    {activeTab === "earning" && "💰 Earning"}

                    {activeTab === "withdrawal" && "💳 Withdrawal"}

                    {activeTab === "ticket" && "🎫 Raised Ticket"}

                  </h5>

                </div>

                <hr />

                {/* Driver Enquiry */}

                {activeTab === "driverEnq" && (
                  <>
                    <div className="inventory-row">
                      <span>Machine</span>
                      <span>{item.machine_name}</span>
                    </div>

                    <div className="inventory-row">
                      <span>Customer</span>
                      <span>{item.name}</span>
                    </div>

                    <div className="inventory-row">
                      <span>Driver Pay</span>
                      <span>₹ {item.driver_pay}</span>
                    </div>

                    <div className="inventory-row">
                      <span>Status</span>
                      <span>{item.driver_status}</span>
                    </div>

                    <div className="inventory-row">
                      <span>Payment</span>
                      <span>{item.pay_status}</span>
                    </div>
                  </>
                )}

                {/* Earnings */}

                {activeTab === "earning" && (
                  <>
                    <div className="inventory-row">
                      <span>Amount</span>
                      <span>₹ {item.amount}</span>
                    </div>

                    <div className="inventory-row">
                      <span>Platform Fee</span>
                      <span>₹ {item.platform_fee}</span>
                    </div>

                    <div className="inventory-row">
                      <span>Payment Type</span>
                      <span>{item.pay_mode}</span>
                    </div>

                    <div className="inventory-row">
                      <span>Status</span>
                      <span>{item.pay_status}</span>
                    </div>
                  </>
                )}

                {/* Withdrawal */}

                {activeTab === "withdrawal" && (
                  <>
                    <div className="inventory-row">
                      <span>Amount</span>
                      <span>₹ {item.amount}</span>
                    </div>

                    <div className="inventory-row">
                      <span>Platform Fee</span>
                      <span>₹ {item.platform_fee}</span>
                    </div>

                    <div className="inventory-row">
                      <span>Payment</span>
                      <span>{item.pay_status}</span>
                    </div>

                    <div className="inventory-row">
                      <span>Date</span>
                      <span>{formatDate(item.d_withdraw)}</span>
                    </div>
                  </>
                )}

                {/* Ticket */}

                {activeTab === "ticket" && (
                  <>
                    <div className="inventory-row">
                      <span>Description</span>
                      <span>{item.description}</span>
                    </div>

                    <div className="inventory-row">
                      <span>Status</span>
                      <span>{item.status}</span>
                    </div>

                    <div className="inventory-row">
                      <span>Raised On</span>
                      <span>{formatDate(item.raised_on)}</span>
                    </div>
                  </>
                )}

              </div>

            </div>
          ))
        ) : (
          <div className="col-12">
            <div className="alert alert-light text-center">
              No Data Found
            </div>
          </div>
        )}

      </div>
    </div>
  </>
)}

    </div>
  )
}

export default Activity
